import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function WalletIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="WalletIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                id="FontAwsome_wallet_"
                d="M15.033,35.129H2.608a.522.522,0,0,1,0-1.043H15.124a.521.521,0,0,0,.522-.522A1.565,1.565,0,0,0,14.081,32h-12A2.086,2.086,0,0,0,0,34.086V44.517A2.086,2.086,0,0,0,2.086,46.6H15.033a1.614,1.614,0,0,0,1.656-1.565V36.694A1.614,1.614,0,0,0,15.033,35.129Zm-1.473,6.78A1.043,1.043,0,1,1,14.6,40.866,1.043,1.043,0,0,1,13.56,41.909Z"
                transform="translate(0.5 -31.5)"
                fill="none"
                stroke="#fff"
                strokeWidth="1"
            />
        </SvgIcon>
    );
}
